import React, { useEffect, useLayoutEffect } from "react";
import styled from "styled-components";
import PullToRefresh from "react-simple-pull-to-refresh";

import { Link } from "react-router-dom";
import { useNavigationType } from "react-router";
import { useSelector, useDispatch, batch } from "react-redux";
import {
  fetchPageScroll,
  fetchReset,
  fetchSearchDate,
  fetchSearchFilter,
  fetchSearchPartnerAndBranch,
} from "redux/slices/sales/salesSlice";

import { MainLayout } from "layouts";
import { getToday } from "utils/date";
import { Avatar, NotificationIcon } from "components/common";
import PullToRefreshing from "components/common/PullToRefreshing";

import SearchInfo from "./home/SearchInfo";
import PeriodInfo from "./home/PeriodInfo";
import VoucherInfo from "./home/VoucherInfo";
import ReceivableInfo from "./home/ReceivableInfo";
import PopupBranch from "components/ui/popup/Branch";

/**
 * [매출 인덱스]
 */

export const Sales = (props) => {
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const { userInfo } = useSelector((state) => state.user);
  const { searchPartner, searchBranch, searchDate } = useSelector(
    (state) => state.sales
  );
  const { seqPartner, seqPartnerBranch } = useSelector(
    (state) => state.partner
  );

  useEffect(() => {
    if (navigationType == "POP") {
      batch(() => {
        dispatch(fetchSearchFilter());
        dispatch(fetchPageScroll("restore"));
      });
    } else {
      dispatch(fetchReset());
    }
  }, []);

  useEffect(() => {
    if (searchPartner != seqPartner || searchBranch != seqPartnerBranch) {
      dispatch(
        fetchSearchPartnerAndBranch({
          searchPartner: seqPartner,
          searchBranch: seqPartnerBranch,
        })
      );
    }
    const today = getToday();
    if (!searchDate) {
      dispatch(fetchSearchDate(today));
    } else if (navigationType == "POP") {
      dispatch(fetchSearchDate(searchDate || today));
    }
  }, [seqPartner, seqPartnerBranch, searchDate]);

  useLayoutEffect(() => {
    return () => {
      dispatch(fetchPageScroll("store"));
    };
  }, []);

  const eventHandler = {
    pullToRefresh: () => {
      return new Promise(() => {
        setTimeout(() => {
          window.location.reload();
        }, 700);
      });
    },
  };

  return (
    <PullToRefresh
      onRefresh={eventHandler.pullToRefresh}
      resistance={2}
      pullingContent={<></>}
      refreshingContent={<PullToRefreshing />}
    >
      <MainLayout
        withHeader
        withBottomTab
        backgroundColor="var(--lightBlue)"
        headerProps={{
          withBackButton: false,
          padding: "14px 24px 14px 24px",
          backgroundColor: "var(--lightBlue)",
          leftComponent: () => {
            return <PopupBranch isAll={true} />;
          },
          rightComponent: () => (
            <RightWrap>
              <NotificationIcon />
              <Link to="/all">
                <Avatar src={userInfo.imageUrl} size={32} minSize={false} />
              </Link>
            </RightWrap>
          ),
        }}
        withPartner={true}
      >
        <Wrapper>
          <SearchInfo />
          <PeriodInfo />
          <VoucherInfo />
          <ReceivableInfo />
        </Wrapper>
      </MainLayout>
    </PullToRefresh>
  );
};

const Wrapper = styled.div`
  padding: var(--padding);
  padding-top: 0;
`;

const RightWrap = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 18px;
`;

export default Sales;
